import React, { useState } from 'react';
import { pinagareAPIURL } from '../../Constant';
import { trackPromise } from 'react-promise-tracker';
import { ToastContainer, toast } from "react-toastify";
//'initial' | 'uploading' | 'success' | 'fail'

const SingleFileUploader = (props) => {

  const [file, setFile] = useState(null);
  const [status, setStatus] = useState('initial');

  const handleFileChange = (e) => {
    if (e.target.files) {
      setStatus('initial');
      setFile(e.target.files[0]);
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();

    if (file) {

      setStatus('uploading');

      const formData = new FormData();
      
      formData.append('eng', "upload_pinagare_file");
      formData.append('efe', props.eng);
      formData.append('file', file);
      formData.append('omang', localStorage.getItem('username'));

      const body_t=JSON.stringify({
        
        omang:localStorage.getItem('username'),
        eng:'upload_pinagare_file', 
        efe:props.eng,
        file:file,      
        
      });

      try {//'http://localhost/pinagare/backend/upload.php'
        const result = await fetch(pinagareAPIURL, {
          method: 'POST',
          body: formData,
        });

        const data = await result.json();

        if(data.status!=null&&data.status!=undefined&&data.status){
          toast.success(data.message);
          setStatus('success');
        }
        else{
          if(data.status!=null&&data.status!=undefined){
            toast.error(data.message);
          }
          else{
          toast.error("Ooops..an internal error occurred. Please try again shortly");
          }
          setStatus('fail');
        }

       // console.log(data);
        
      } catch (error) {
        //console.error(error);
        toast.error("Ooops..an internal error occurred. Please try again shortly [2]".error);
        setStatus('fail');
      }
    }
  }
  

  return (
    <>
      <div className="input-group">
        <label htmlFor="file" className="sr-only">
          Choose a file
        </label>
     {status!='success'?   <input style={{border:"2px solid #6ec6ec"}} className='form-control input_bodara' id="file" name="file" type="file" onChange={handleFileChange} />
     :null} <input type="hidden" name="eng" id="eng" value="upload_pinagare_file" defaultValue="upload_pinagare_file" />
      <input type="hidden" name="efe" id="efe" value={props.eng} defaultValue={props.eng} />
      </div>
      {/*file && (
        <section>
          File details:
          <ul>
            <li>Name: {file.name}</li>
            <li>Type: {file.type}</li>
            <li>Size: {file.size} bytes</li>
          </ul>
        </section>
      )*/}

      {status!='success'? (file && (<span><br />
        <button style={{border:"2px solid #6ec6ec"}} className='submit form-control input_bodara' onClick={ (e) => {trackPromise(handleUpload(e))}} >
          Upload the file
        </button><hr /></span> 
      )):<p style={{color:"green"}}>✅ "File uploaded successfully!"</p>}

      <Result status={status} />
    </>
  );
};

const Result = ( status ) => {
  if (status === "success") {
    return <p>✅ File uploaded successfully!</p>;
  } else if (status === "fail") {
    return <p>❌ File upload failed!</p>;
  } else if (status === "uploading") {
    return <p>⏳ Uploading selected file...</p>;
  } else {
    return null;
  }
};

export default SingleFileUploader;